import { useMutation } from "@tanstack/react-query";
import { subscribeNewsletter } from "@/lib/newsletter/newsletter";

export const useNewsletterSubscribe = () => {
  return useMutation({
    mutationFn: async (data) => {
      const res = await subscribeNewsletter(data);
      return res;
    },
  });
};
